<template>
  <div id="app mt-0" class="container-fluid p-0 m-0 basics-20-bg" style="height: 100%; width: 100%">
    <nav
      class="navbar navbar-expand-sm bg-white p-0 px-5 justify-content-between"
      style="height: 50px; padding-left: 4rem; padding-right: 4rem"
    >
      <div class="navbar-brand">
        <a href="profil" class="ml-2">
          <img :src="require(`@/assets/logo/${logo}`)" style="max-height: 40px;" class="py-1 mr-2">
          <img :src="require('@/assets/logo/logo-codoc.svg')" class="ml-2">
        </a>
      </div>

      <div v-if="isIdentified()">
        <ul class="navbar-nav">
          <li class="d-inline-flex align-items-center">
            <span class="text-nowrap" style="text-transform: capitalize;">
              {{ user().user_info.given_name }} {{ user().user_info.family_name }} -
            </span>
            <button class="btn btn-link px-1" @click="logout()">
              Se déconnecter
            </button>
          </li>
        </ul>
      </div>
    </nav>
    <router-view />
  </div>
</template>

<script>
  import AuthService from "./services/auth.service";

  export default {
    name: 'App',
    data() {
      return {
        logo: process.env.VUE_APP_HOSPITAL_LOGO,
      };
    },

    methods: {
      logout() {
        sessionStorage.clear();
        AuthService.logout();
      },

      isIdentified() {
        return AuthService.isIdentified();
      },

      user() {
        return AuthService.getUserInfos();
      }
    },
  };
</script>

<style>
  @import './assets/style.css';
</style>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
  }

  .navbar {
    border: 1px solid #D5D7DE;
    box-shadow: 0px 1px 2px rgba(19, 34, 57, 0.12);
  }

  html, body {
    height: 100%;
    width: 100%;
    background-color: var(--basics-20-bg);
  }
</style>
